import React from "react";
import { number, object } from "prop-types";
import { useIntl } from "react-intl";
import RequiredAccessoriesAddonsDetails from "../../../requiredAccessoriesAddonsListing/RequiredAccessoriesAddonsDetails";

const ForcedItemsDetails = (props) => {
  const { forcedItemDetails = {}, mainProductQty = 1 } = props || {};

  const intl = useIntl();

  return (
        <>
          <div className="rentals_list_container">
            <div className="rentals_list">
                <RequiredAccessoriesAddonsDetails mainProductQty={mainProductQty} forcedItemsDetails={forcedItemDetails} isModalView={true} title={intl.formatMessage({
                  id: "add-to-cart-modal-accessories-section-title",
                })}/>
            </div>
          </div>
        </>
  );
};

ForcedItemsDetails.propTypes = {
    forcedItemDetails: object,
    mainProductQty: number
};

export default React.memo(ForcedItemsDetails);
